import { PropsWithChildren } from 'react';
import { DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';
import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export interface Props {
  inlineCss?: FlattenInterpolation<ThemeProps<DefaultTheme>>;
}

export default function CompanySectionTitle({ children, inlineCss }: PropsWithChildren<Props>) {
  return <Wrapper inlineCss={inlineCss}>{children}</Wrapper>;
}

export const Wrapper = styled.div<Pick<Props, 'inlineCss'>>`
  color: ${({ theme }) => theme.colors.gray900};
  text-align: left;
  ${getFontStyle('bold120_B2')};
  ${({ inlineCss }) => inlineCss};

  display: flex;
  align-items: center;
  margin-bottom: 16px;

  gap: 5px;
`;
